import nprogress from 'nprogress';
import type { Router } from 'vue-router';

import { analyticsGuard } from './analytics-guard';
import { authGuard } from './auth-guard';
import { createDatePreservationGuard } from './date-preservation';
import { dateRedirectGuard } from './date-redirect';

/**
 * global router guard
 * now only used for progress bar
 */
function setupCommonGuard(router: Router) {
  router.beforeEach(() => {
    nprogress.start();
    return true;
  });
  router.afterEach(() => {
    nprogress.done();
    return true;
  });
}

export function createRouterGuard(router: Router) {
  // Date redirect must run first to ensure URL params are correct
  dateRedirectGuard(router);

  // Preserve date range between pages with preserveDateRange meta field
  createDatePreservationGuard(router);

  setupCommonGuard(router);
  authGuard(router);

  // Analytics tracking (runs after navigation completes)
  analyticsGuard(router);
}
